import { BlastPoolsData, PoolInfo } from "./types";

export default function getSortedBlastPool(data: BlastPoolsData) {
  const blastPoolInfo: PoolInfo[] = Object.entries(data)
    .map((item) => ({ ...item[1], PoolId: Number(item[0]) }))
    .sort((a, b) => a.BuyInAmount - b.BuyInAmount);

  return blastPoolInfo;
}
